import { Wording } from '@/types';

export const COOKING_WORDING_PL: Wording = {
  components_header_media_content: 'Filmy o gotowaniu',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Przepisy',
  components_header_text2: 'Blog',
  components_header_members: 'Członkowie',
  hero_text: 'Gotuj z pasją, jedz z radością',
  hero_button_text: 'Zacznij gotować już dziś',
  components_ressources_section_title: 'ZASOBY',
  components_ressources_subheader_text: 'Wszystkie zasoby, których potrzebujesz, aby nauczyć się gotować i tworzyć lepsze jedzenie',
  components_ressources_span_text: 'Odkryj bogatą kolekcję przepisów wideo, szczegółowych poradników kulinarnych i porad ekspertów na temat łączenia smaków, prezentacji potraw i kulinarnej kreatywności.',
  components_ressources_card_1_title: 'Inspiracja kulinarna',
  components_ressources_card_1_text: 'Zainspiruj się kreatywnymi przepisami i filmami kulinarnymi.',
  components_ressources_card_2_title: 'Wiedza o gotowaniu',
  components_ressources_card_2_text: 'Poznaj podstawowe techniki gotowania, łączenia smaków i zasady łączenia potraw dzięki przejrzystym i praktycznym przewodnikom.',
  components_ressources_link: 'Oglądaj filmy',
  components_notes_and_google_title_1: 'Edukacja kulinarna',
  components_notes_and_google_title_2: 'Codzienne gotowanie',
  components_notes_and_google_title_3: 'Stałe umiejętności kulinarne',
  components_review_google_text: 'Recenzje w Google',
  media_content_section_title: 'Filmy o gotowaniu',
  media_content_section_subheader_text: 'Odkryj przepisy i filmy instruktażowe dotyczące gotowania krok po kroku.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Więcej filmów',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Przewodniki i artykuły',
  text2_section_button_more: 'Więcej artykułów',
  components_text1_section_title: 'PRZEPISY',
  components_text1_subheader_text: 'Pyszne przepisy na codzienne gotowanie',
  components_text1_span_text: 'Odkryj proste przepisy na codzienne posiłki, jasne instrukcje i świetne rezultaty.',
  components_text1_card_1_title: 'Zacznij swój dzień dobrze',
  components_text1_card_1_text: 'Proste i smaczne przepisy, dzięki którym łatwo i przyjemnie rozpoczniesz dzień.',
  components_text1_card_3_title: 'Pomysły na pyszny lunch',
  components_text1_card_3_text: 'Pyszne przepisy na lunch, łatwe w przygotowaniu i pełne smaku.',
  components_text1_card_2_title: 'Przepisy na pocieszające obiady',
  components_text1_card_2_text: 'Przepisy na ciepłe, sycące dania obiadowe, idealne na relaksujące wieczory w domu.',
  components_text1_link: 'Zobacz wszystkie przepisy',
  components_footer_text: 'Naucz się lepiej gotować, twórz lepsze jedzenie: Twoja kuchnia, Twoja podróż.',
  components_footer_info: 'Informacje',
  components_footer_registration_number: 'Numer rejestracyjny',
  components_footer_legal: 'Prawny',
  components_footer_terms: 'Warunki korzystania z serwisu',
  components_footer_privacy: 'Polityka prywatności',
  button_load_more: 'Załaduj więcej',
  page_media_1_content_hero_text: 'Odkryj proste filmy instruktażowe na każdy gust',
  page_text1_hero_text: 'Przepisy',
  page_text1_section_title: 'Porady kulinarne',
  page_text1_subheader_text: 'Przepisy',
  page_text2_hero_text: 'Nasz blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Przewodniki i artykuły',
  enter_email_title: 'Proszę podać swój adres e-mail, aby kontynuować',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Wchodzić',
  components_login_success_text: 'Logowanie pomyślne!',
  components_card_link_media_content: 'Oglądaj teraz',
  components_card_link_text1_content: 'Zobacz przepis',
  components_card_link_text2_content: 'Zobacz artykuł',
};